import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import {
  pgViewChargesActionId,
  sessionExpireMessage,
  toastError,
  tokenInavlidMessage,
} from "../../../utils/constants";
import { fill_action } from "../../../actions/fillCombo_action";
import Header from "../../../common_components/Header";
import Modal from "react-bootstrap/Modal";
import {
  getCartList_action,
} from "../../../actions/userAction/cart_action";
import { sendPaymentForm_action } from "../../../actions/paymentAction/paymentAction";
import moment from "moment";
import Loader from "../../../utils/Loader";

class Cart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOpen: false,
      cartList: [],
      otherDetail: [],
      pgViewChargesModal: false,
      pgViewChargesFillList: [],
      PanNo: "",
      GSTNo: "",
      isAllChecked: false,
      checkBoxFlag: false,
      toPay: "",
      countryId: "",
      displayPIlist: "",
      showRequestButton: true,
      showRedeemSection: false,
      showSuccessMessage: false,
      PlatformID: 4,
      Total_Payable: "",
      ServiceID: "",
    };
    this.PIRecord = this.PIRecord.bind(this);
    this.handleAllSelected = this.handleAllSelected.bind(this);
    this.handleListClick = this.handleListClick.bind(this);
    this.getCartData = this.getCartData.bind(this);
  }

  componentDidMount() {
    console.log("Cart component mounted");
    this.getCartData();
    this.getFillList(pgViewChargesActionId, "", "", "", "")
    this.setState({
      countryId: JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID,
    });
    var param =
      this.props.params != "" &&
        Object.keys(this.props.params).length != 0 &&
        this.props.params != undefined &&
        this.props.params != null
        ? this.props.params
        : null;
    var status =
      param != null
        ? param.status != undefined &&
          param.status != "" &&
          param.status != null
          ? param.status
          : null
        : null;
    if (status != null) {
      if (JSON.parse(sessionStorage.getItem("isNavToPayment")) == true) {
        if (status == "Success") {
          this.setState({
            isOpen: true,
          });
        } else if (status == "Failure") {
          toastError("Something went wrong! Please try again later.");
        } else if (status == "Invalid") {
          toastError("Payment for the order is already processed");
        }
      }
    }
  }
  getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
    this.setState({ isLoading: true });
    return new Promise((resolve) => {
      this.props
        .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
        .then((data) => {
          if (data.error != 1) {
            if (actionID === pgViewChargesActionId) {
              this.setState({ pgViewChargesFillList: data.data });
              resolve(true);
            }
          } else {
            this.setState({ isLoading: false });
          }
        });
    });
  }
  togglePGCharges() {
    this.setState({ pgViewChargesModal: !this.state.pgViewChargesModal });
  }
  handleAllSelected(e) {
    const { cartList, isAllChecked } = this.state;
    if (isAllChecked) {
      cartList.map((data) => {
        data.isChecked = 0;
      });
      this.setState({ isAllChecked: false });
    } else {
      cartList.map((data) => {
        data.isChecked = 1;
      });
      this.setState({ isAllChecked: true });
    }

    this.setState({ cartList: cartList }, () => {
      this.calculateToPay();
    });

    const checkboxSelected = cartList.some((item) => item.isChecked == 1);
    setTimeout(() => {
      if (checkboxSelected) {
        this.setState({ checkBoxFlag: true });
      } else {
        this.setState({ checkBoxFlag: false });
      }
    }, 100);
  }

  handleListClick(e, id) {
    const { cartList, isAllChecked } = this.state;
    cartList.map((data, index) => {
      if (data.ProformaInvoiceID == id) {
        if (!data.isChecked) {
          data.isChecked = 1;
        } else {
          data.isChecked = 0;
        }
      }
    });

    this.setState({ cartList: cartList }, () => {
      this.calculateToPay();
    });
    const checkboxSelected = cartList.some((item) => item.isChecked == 1);
    setTimeout(() => {
      if (checkboxSelected) {
        this.setState({ checkBoxFlag: true });
      } else {
        this.setState({ checkBoxFlag: false });
      }
    }, 100);

    const allSelected = cartList.every((item) => item.isChecked == 1);
    setTimeout(() => {
      if (allSelected) {
        this.setState({ isAllChecked: true });
      } else {
        this.setState({ isAllChecked: false });
      }
    }, 100);
  }

  calculateToPay() {
    const { isAllChecked, cartList } = this.state;
    var amount = 0;
    cartList.map((data, index) => {
      if (data.isChecked == 1) {
        amount = amount + data.Pending;
      }
    });
    this.setState({ toPay: amount });
  }

  PIRecord(cartList) {
    const { isAllChecked } = this.state;
    return (
      <table className="table table-bordered table-striped mg-b-0">
        <thead>
          <tr>
            <th className="text-center">
              <input
                type="checkbox"
                class="custom-control-input"
                value={isAllChecked}
                checked={isAllChecked}
              />
              <label
                style={{
                  marginTop: 0,
                  paddingLeft: "10px",
                  marginBottom: "1.5em",
                }}
                class="custom-control-label"
                onClick={(e) => this.handleAllSelected(e)}
              ></label>
            </th>
            <th>Proforma Invoice No.</th>
            <th>Service Name</th>
            <th>Proforma Date</th>
            <th>Taxable Amount</th>
            <th>Tax Type</th>
            <th>CSGT</th>
            <th>SGST</th>
            <th>IGST</th>
            <th>Total Payable</th>
            <th>Pending</th>
          </tr>
        </thead>
        <tbody id="myTable">
          {cartList.length > 0 ? (
            cartList.map((data, i) => (
              <tr key={i}>
                <td className="text-center" style={{ paddingRight: "20px" }}>
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    value={data.isChecked}
                    checked={data.isChecked}
                    onClick={(e) =>
                      this.handleListClick(e, data.ProformaInvoiceID)
                    }
                  />
                  <label
                    onClick={(e) =>
                      this.handleListClick(e, data.ProformaInvoiceID)
                    }
                    class="custom-control-label"
                    style={{
                      marginTop: 0,
                      paddingLeft: "10px",
                      marginBottom: "1.5em",
                    }}
                  ></label>
                </td>
                <td>{data.ProformaInvoiceNo}</td>
                <td>{data.ServiceName}</td>
                <td>{moment(data.ProformaInvoiceDate).format("DD/MM/YYYY")}</td>
                <td>{data.TaxableAmount}</td>
                <td>{data.Tax_Type}</td>
                <td>{data.CGST}</td>
                <td>{data.SGST}</td>
                <td>{data.IGST}</td>
                <td>{data.Total_Payable}</td>
                <td>{data.Pending}</td>
              </tr>
            ))
          ) : (
            <>
              <tr>
                <td colSpan={6}>No Records Found...</td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    );
  }

  getCartData() {
    this.setState({ isLoading: true });
    this.props
      .getCartList_action(
        sessionStorage.getItem("UserIDSS"),
        JSON.parse(sessionStorage.getItem("loginDataSS")).MemberID
      )
      .then((data) => {
        if (data.error !== 1) {
          const otherDetail = data.data[1] || [];
          console.log(data.data[0]);
          data.data[0].length > 0 &&
            data.data[0].map((item) => {
              item.isChecked = 0;
            });
          sessionStorage.setItem("cartItems", data.data[0].length);

          // Declare and assign PanNo, GSTNo properly
          const PanNo = otherDetail[0]?.PanNo || "";
          const GSTNo = otherDetail[0]?.GSTNo || "";

          this.setState({
            isLoading: false,
            cartList: data.data[0],
            otherDetail: data.data[1],
            PanNo: PanNo,
            GSTNo: GSTNo,
          });

          console.log("PanNo", PanNo);
          console.log("GSTNo:", GSTNo);
        } else {
          this.setState({ isLoading: false });
          toastError(data.data.ErrorMsg);
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
        toastError("Failed to fetch data.");
      });
  }



  handleRedeemNow() {
    this.setState({
      showRedeemSection: false,
      showSuccessMessage: true,
    });
  }

  navPayment(e) {
    e.preventDefault();
    const {
      isLoading,
      cartList,
      currentPage,
      checkBoxFlag,
      countryId,
      toPay,
      isOpen,
    } = this.state;
    if (checkBoxFlag) {
      var finalList = [];
      var displayList = [];
      cartList.length > 0 &&
        cartList.map((item) => {
          if (item.isChecked == 1) {
            finalList.push(item);
            displayList.push(item.ProformaInvoiceNo);
          }
        });
      this.setState({ displayPIlist: displayList.toString() });
      this.setState({ isLoading: true });
      this.props
        .sendPaymentForm_action(
          JSON.parse(sessionStorage.getItem("loginDataSS")).MemberID,
          toPay,
          countryId == 91 ? "INR" : "USD",
          finalList,
          "cart"
        )
        .then((data) => {
          console.log(data);
          if (data.error != 1) {
            if (data != null) {
              this.setState({ paymentLink: data.data }, () => {
                sessionStorage.setItem("isNavToPayment", true);
                window.location.replace(data.data);
              });
            }
          } else {
            this.setState({ isLoading: false });
            toastError("There is some problem. Please try again later!");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastError("Please select atleast 1 Proforma Invoice");
    }
  }
  render() {
    const {
      isLoading,
      cartList,
      checkBoxFlag,
      countryId,
      toPay,
      isOpen, pgViewChargesModal
    } = this.state;
    console.log(JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <Header />
        <ToastContainer />
        <section
          class="cart-section"
          style={{ marginBottom: "50px", marginTop: "125px" }}
        >
          <div class="container">
            <div class="row">
              <div class="col-12 col-sm-12 col-lg-12">
                {cartList.length > 0 && (
                  <div className="card shadow-none border mb-2">
                    <div className="card-header py-1">
                      <h6 className="pt-2" style={{ float: "left" }}>
                        Cart
                      </h6>
                    </div>
                  </div>
                )}
                {cartList.length > 0 ? (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card shadow-none border">
                        <div className="card-body  p-2 pb-0">
                          <div className="custom_table">
                            <div className="hack1">
                              <div className="hack2">
                                {this.PIRecord(cartList)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {checkBoxFlag && (
                      <>

                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div className="card shadow-none border">
                              <div className="card-body">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="paymentOption"
                                    id="fullPayment"
                                    defaultChecked
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="fullPayment"
                                  >
                                    Full Payment
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="paymentOption"
                                    id="customPayment"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="customPayment"
                                  >
                                    Custom Payment
                                  </label>
                                </div>
                                <div className="mt-3">
                                  <label htmlFor="remark">Remark</label>
                                  <textarea
                                    id="remark"
                                    className="form-control"
                                    rows="3"
                                  ></textarea>
                                </div>
                                <div className="mt-3 fs-5 fw-bold">
                                  Total: {countryId == 91 ? "₹" : "$"}
                                  {toPay}{" "}
                                  <span className="text-muted text-decoration-line-through">
                                    {countryId == 91 ? "₹" : "$"}
                                    {toPay +
                                      (this.state.redemptionList &&
                                        this.state.redemptionList[0] &&
                                        this.state.redemptionList[0][0]
                                        ? this.state.redemptionList[0][0]
                                          .eligible_redeem_points
                                        : 500)}
                                  </span>
                                </div>
                                {sessionStorage.getItem("isPgButton") == 1 ? <>
                                  <button onClick={() => this.togglePGCharges()} className="btn btn-success mt-2 w-100">
                                    Pay
                                  </button>
                                </> : <></>}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card shadow-none border">
                        <div className="card-body  p-2 pb-0">
                          <div
                            style={{ textAlign: "center", padding: "20px 0px" }}
                            className="col-md-12"
                          >
                            <h6
                              style={{
                                color: "#744587",
                                fontWeight: "600",
                                fontSize: "18px",
                              }}
                            >
                              No Services in Cart
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        <Modal
          show={isOpen}
          onHide={() => this.setState({ isOpen: false })}
          size="xl"
        >
          <Modal.Header>
            <Modal.Title style={{ width: "100%" }}>
              <h4
                className="mb-0 pt-2 thank-top-mes"
                style={{ color: "#318958", textAlign: "center" }}
              >
                <strong style={{ textAlign: "center" }}>
                  Payment Succesful
                </strong>
              </h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-1 mt-1 text-center com-font">
              We have received Payment of {this.state.toPay} against Proforma
              Invoice No {this.state.displayPIlist}
            </p>
            <p className="mb-0 mt-2 text-center com-font">
              <strong>Note:</strong> Kindly check your registered email address
              for acknowledgement of registration.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn ad-fil-btn"
              data-bs-dismiss="modal"
              style={{ background: "#ddd", color: "#000", padding: "4px 16px" }}
              onClick={() => this.setState({ isOpen: !isOpen })}
            >
              Continue
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={pgViewChargesModal}
          onHide={() => this.setState({ pgViewChargesModal: false })}
          size="xl"
        >
          <Modal.Header>
            <Modal.Title style={{ width: "100%" }}>
              <h4
                className="mb-0 pt-2 thank-top-mes"
                style={{ color: "#318958", textAlign: "center" }}
              >
                <strong style={{ textAlign: "center" }}>
                  Bank Charges
                </strong>
              </h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {sessionStorage.getItem("isPgButton") == 1 ? <>
              <div className="mt-3 fs-5 fw-bold">
                <span className="text-danger text-center d-block">
                  Please note that bank charges alongwith GST as per the below table will be applicable as per selected mode of payment in the next step
                </span>
              </div>
              <table className="table table-bordered table-striped mg-b-0">
                <thead>
                  <tr>
                    <th>Payment Mode</th>
                    <th>Bank Charges</th>
                  </tr>
                </thead>
                <tbody id="myTable">
                  {this.state.pgViewChargesFillList.length > 0 ? (
                    this.state.pgViewChargesFillList.map((data, i) => (
                      <tr key={i}>
                        <td className={data.isParent ? 'fw-bold' : ""}>{data.Description}</td>
                        <td>{data.Value}</td>
                      </tr>
                    ))
                  ) : (
                    <>
                      <tr>
                        <td colSpan={6}>No Records Found...</td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </> : <></>}
          </Modal.Body>
          <Modal.Footer>
            <form
              onSubmit={(e) => this.navPayment(e)}
              id="nonseamless"
              method="post"
              name="redirect"
            >
              <button className="btn btn-success mt-2 w-100">
                I agree & Proceed to Pay
              </button>
            </form>
            <button
              type="button"
              className="btn ad-fil-btn"
              data-bs-dismiss="modal"
              style={{ background: "#ddd", color: "#000", padding: "4px 16px" }}
              onClick={() => this.togglePGCharges()}
            >
              OK
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    fill_action,
    getCartList_action,
    sendPaymentForm_action,
  })(Cart)
);
